import type { HttpTypes } from "@medusajs/types";
import type { BaseAddressData } from "./address-schema";

/** The address fields every form-to-API mapping carries, and nothing else. */
export type AddressFieldsInput = Pick<
  HttpTypes.StoreCreateCustomerAddress,
  | "first_name"
  | "last_name"
  | "company"
  | "address_1"
  | "address_2"
  | "city"
  | "postal_code"
  | "province"
  | "country_code"
  | "phone"
>;

/**
 * Maps the address form's values to the API payload: the fields shared by every
 * place that saves an address (the account dialog, checkout's dialog, first-login
 * onboarding).
 *
 * The form holds an unfilled optional field as `""`; the API wants it absent, so
 * those become `undefined`. What is deliberately NOT here is whatever differs
 * per caller - the nickname (`address_name`: required in the account, optional
 * in checkout, defaulted in onboarding) and the default-address flags - so each
 * caller adds its own beside the call.
 */
export function toAddressInput(data: BaseAddressData): AddressFieldsInput {
  return {
    first_name: data.first_name,
    last_name: data.last_name,
    company: data.company || undefined,
    address_1: data.address_1,
    address_2: data.address_2 || undefined,
    city: data.city,
    postal_code: data.postal_code,
    province: data.province || undefined,
    country_code: data.country_code,
    phone: data.phone || undefined
  };
}
